var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "thead",
    { class: [_vm.$style["mds-thead"], _vm.classObject] },
    [
      _vm.nestedHeaders
        ? _vm._l(_vm.nestedHeaders, function (n, index) {
            return _c(
              "tr",
              { key: index, class: _vm.$style["mds-thead__group"] },
              [
                _vm.multiselection
                  ? _c("th", { staticStyle: { width: "30px" } })
                  : _vm._e(),
                _vm._v(" "),
                _vm.rowNumbers
                  ? _c("th", { staticStyle: { width: "20px" } })
                  : _vm._e(),
                _vm._v(" "),
                _vm._t(`mds-thead-group-${n}`),
              ],
              2
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "tr",
        [
          _vm.multiselection
            ? _c(
                "th",
                {
                  class: _vm.$style["mds-thead__th-selection"],
                  attrs: { scope: "col" },
                },
                [
                  !_vm.hiddenGlobalSelect
                    ? _c("mds-checkbox", {
                        attrs: {
                          "hidden-label": true,
                          label: _vm.multiselectionLabel,
                          value: _vm.multiselectionLabel,
                          indeterminate: _vm.indeterminate,
                          checked: _vm.checked,
                          "on-dark": _vm.onDark,
                          size: _vm.size,
                        },
                        nativeOn: {
                          change: function ($event) {
                            return _vm.emitHeaderSelectEvent($event)
                          },
                        },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.rowNumbers
            ? _c("th", { class: _vm.$style["mds-thead__th-numbered"] }, [
                _c(
                  "span",
                  { class: _vm.$style["mds-thead__th-numbered-label"] },
                  [_vm._v(_vm._s(_vm.rowNumberLabel))]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._t("default"),
        ],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }